"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformPlaceholders = transformPlaceholders;

var _types = require("./types");

var _types2 = _interopRequireDefault(_types);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function isIndexedPlaceholderPath(phPath) {
  return phPath.node.index != null;
}function isSpreadPlaceholderPath(phPath) {
  var _ref;

  return ((_ref = phPath.parentPath) == null ? null : _ref.node.type) === "SpreadElement";
}function isNonIndexedPlaceholderPath(phPath) {
  return !(phPath.node.index != null) && !isSpreadPlaceholderPath(phPath);
}function registerPlaceholder(functions, path, programPath) {
  var _ref2;

  var fnPath = path.getFunctionParent();
  if (fnPath === programPath || !fnPath.node || !fnPath.node.params) {
    throw path.buildCodeFrameError("Placeholders cannot be used outside functions.");
  }if (fnPath.node.params.length) {
    throw path.buildCodeFrameError("Placeholders cannot be used in functions with arguments.");
  }if ((((_ref2 = path.parentPath) == null ? null : _ref2.node) == null ? null : _ref2.node.type) === "SpreadElement") {
    var _ref3;

    if (((_ref3 = path.node) == null ? null : _ref3.index) != null) {
      throw path.buildCodeFrameError("Cannot use indices with spread placeholders.");
    }
  }var fnInfo = functions.get(fnPath);
  if (fnInfo) {
    return fnInfo.placeholders.push(path);
  } else {
    return functions.set(fnPath, { functionPath: fnPath, placeholders: [path] });
  }
}function liftPlaceholders(fnPath, phPaths) {
  // Collate placeholders
  var ixPhPaths = phPaths.filter(isIndexedPlaceholderPath);
  var nixPhPaths = phPaths.filter(isNonIndexedPlaceholderPath);
  var spreadPhPaths = phPaths.filter(isSpreadPlaceholderPath);

  if (ixPhPaths.length > 0 && nixPhPaths.length > 0) {
    throw fnPath.buildCodeFrameError("Cannot mix indexed and non-indexed placeholders in a function.");
  } // Formulate args
  var args = [];
  var restArg = undefined;
  var maxArg = ixPhPaths.length > 0 ? Math.max.apply(Math, _toConsumableArray(ixPhPaths.map(function (x) {
    return x.node.index;
  }))) + 1 : nixPhPaths.length > 0 ? 1 : 0;
  // Generate unique identifiers for args
  for (var i = 0; i < maxArg; i++) {
    args.push(fnPath.scope.generateUidIdentifier("arg"));
  }if (spreadPhPaths.length > 0) {
    restArg = fnPath.scope.generateUidIdentifier("arg");
    args.push(_types2.default.restElement(restArg));
  } // Replace placeholders with references to args
  for (var _i4 = 0, _len4 = nixPhPaths.length; _i4 < _len4; _i4++) {
    var _phPath = nixPhPaths[_i4];_phPath.replaceWith(args[0]);
  }for (var _i5 = 0, _len5 = ixPhPaths.length; _i5 < _len5; _i5++) {
    var _phPath2 = ixPhPaths[_i5];_phPath2.replaceWith(args[_phPath2.node.index]);
  }for (var _i6 = 0, _len6 = spreadPhPaths.length; _i6 < _len6; _i6++) {
    var _phPath3 = spreadPhPaths[_i6];_phPath3.replaceWith(restArg);
  } // Replace function definition arg list
  var fnNode = fnPath.node;
  fnNode.params = args;
  return fnPath.replaceWith(fnNode);
} // Collect all functions with placeholders into a Map, one entry per function
function findFunctionsWithPlaceholders(programPath) {
  var fns = new Map();
  programPath.traverse({
    PlaceholderExpression(path) {
      registerPlaceholder(fns, path, programPath);
    } });
  return fns;
}function transformPlaceholders(programPath) {
  var fns = findFunctionsWithPlaceholders(programPath);
  return fns.forEach(function (fnInfo) {
    return liftPlaceholders(fnInfo.functionPath, fnInfo.placeholders);
  });
}